import React from 'react'
import { Switch } from '@mui/material'

import * as Styled from './styles'

interface Props {
  id: string
  label: string
  info?: string
  readMoreText?: string
  onReadMore?: () => void
  checked: boolean
  disabled?: boolean
  onChange: (checked: boolean) => void
  testId?: string
  className?: string
}

const LabeledSwitch: React.FC<Props> = ({
  id,
  label,
  info,
  readMoreText,
  onReadMore,
  checked,
  disabled = false,
  onChange,
  testId,
  className,
}) => {
  const infoId = `${id}-info`

  return (
    <Styled.LabeledSwitch className={className}>
      <Styled.Label
        htmlFor={id}
        $disabled={disabled}
        // Toggles without moving focus to the switch, which Chrome would otherwise mark as keyboard focus
        onClick={(event) => {
          event.preventDefault()
          if (!disabled) onChange(!checked)
        }}
      >
        {label}
      </Styled.Label>

      <Switch
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        inputProps={{ 'aria-describedby': info ? infoId : undefined }}
        data-testid={testId}
      />

      {info && (
        <Styled.Info>
          <span id={infoId}>{info}</span>
          {readMoreText && onReadMore && (
            <>
              {' '}
              <Styled.ReadMore type="button" className="labeled-switch-read-more" onClick={onReadMore}>
                {readMoreText}
              </Styled.ReadMore>
            </>
          )}
        </Styled.Info>
      )}
    </Styled.LabeledSwitch>
  )
}

export default LabeledSwitch
